import apiClient from './api';

const paymentService = {
    createCheckout: async ({ planId, couponCode }) => {
        const response = await apiClient.post('/api/payments/checkout', { planId, couponCode: couponCode || undefined });
        return response.data; // { redirectUrl, orderId }
    },

    // --- SSLCommerz gateway (runs alongside Moneybag) ---
    // Same request/response shape as createCheckout, but routed to the SSLCommerz flow.
    // channel (optional): 'bkash' | 'rocket' — limits the gateway page to that channel.
    createCheckoutSSL: async ({ planId, couponCode, channel }) => {
        const response = await apiClient.post('/api/payments/ssl/checkout', { planId, couponCode: couponCode || undefined, channel: channel || undefined });
        return response.data; // { redirectUrl, orderId }
    },

    // --- FastSpring gateway (international / USD, for non-BD users) ---
    // Returns { sessionId, orderId } — the popup is opened via fastspring.builder.checkout(sessionId).
    createCheckoutFastSpring: async ({ planId, couponCode }) => {
        const response = await apiClient.post('/api/payments/fastspring/checkout', { planId, couponCode: couponCode || undefined });
        return response.data; // { sessionId, orderId }
    },

    // SSLCommerz verify — the backend queries SSLCommerz by our tran_id (order id), so no
    // gateway transactionId needs to be passed from the redirect. ref = orderId.
    verifyPaymentSSL: async (ref) => {
        const response = await apiClient.post(`/api/payments/ssl/verify/${ref}`, {});
        return response.data; // { status, credits }
    },

    getHistory: async ({ page = 1, limit = 20 } = {}) => {
        const response = await apiClient.get('/api/payments/history', { params: { page, limit } });
        return response.data; // { transactions, pagination }
    },

    // Soft-deletes one of the user's own payments from their history (the backend refuses a PENDING one).
    deletePayment: async (orderId) => {
        const response = await apiClient.delete(`/api/payments/${orderId}`);
        return response.data;
    },

    getStatus: async (orderId) => {
        const response = await apiClient.get(`/api/payments/status/${orderId}`);
        return response.data; // { id, amount, credits, status, orderId, failureReason, createdAt }
    },

    // ref: gatewayTxnId for rechecks (falls back to orderId — the backend accepts either).
    // transactionId: Moneybag's transaction_id from redirect URL query param (redirect flow).
    verifyPayment: async (ref, transactionId) => {
        const response = await apiClient.post(`/api/payments/verify/${ref}`, { transactionId });
        return response.data; // { status, credits }
    },

    // Public social-proof feed for the buy-credit page. Returns
    // { buyers: [{ fullName, shopName, district, avatar, credits, at }], todayBuyers, monthlyBuyers }.
    // The buyers list is a 30-min cache; todayBuyers/monthlyBuyers are EXACT successful-transaction
    // counts for today / this calendar month (Dhaka time), read fresh so they never roll backward.
    getRecentBuyers: async () => {
        const response = await apiClient.get('/api/payments/recent-buyers');
        return response.data; // { buyers: [...], todayBuyers, monthlyBuyers }
    },

    // Check if the owner of a given office space has at least one successful payment
    getOwnerHasPayment: async (officeSpaceId) => {
        const response = await apiClient.get('/api/payments/owner-has-payment', { params: { officeSpaceId } });
        return response.data; // { hasPayment: boolean }
    },
};

export default paymentService;
